import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    // Initialize tooltips if Bootstrap is available
    this.initializeTooltips()
  }

  initializeTooltips() {
    if (bootstrap && bootstrap.Tooltip) {
      const tooltips = this.element.querySelectorAll('[data-toggle="tooltip"]')
      tooltips.forEach(tooltip => {
        new bootstrap.Tooltip(tooltip)
      })
    }
  }

  autoSubmit(event) {
    // Add loading state to form
    this.element.classList.add('loading')

    // Show visual feedback that the calendar is updating
    const loadingIndicator = document.createElement('div')
    loadingIndicator.className = 'calendar-loading-indicator'
    loadingIndicator.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Actualizando...'

    const calendar = document.querySelector('.weekly-calendar')
    if (calendar) {
      calendar.appendChild(loadingIndicator)
      calendar.classList.add('loading')
    }

    // Submit the form automatically
    this.element.requestSubmit()
  }
}
